import { createContext } from 'react';
/**
 * A React context that provides access to an ArrayInput methods as provided by react-hook-form
 * Useful to create custom array input iterators.
 * @see {ArrayInput}
 * @see {@link https://react-hook-form.com/api/usefieldarray}
 */
export var ArrayInputContext = createContext(undefined);
//# sourceMappingURL=ArrayInputContext.js.map